import type { AdminCustomerRow } from "@ternary/contracts"

/** The history state a list row's link carries, so the record's back link returns to that list. */
export type CustomerRecordState = { customerList: string }

/** The name an admin sees for a customer: first and last, or the email when both are empty. */
export function fullName(row: Pick<AdminCustomerRow, "email" | "firstName" | "lastName">) {
  return `${row.firstName} ${row.lastName}`.trim() || row.email
}

const DISCORD_AVATAR_HOSTS = new Set(["cdn.discordapp.com", "media.discordapp.net"])

/**
 * A customer's Discord avatar address, only when it is https on Discord's CDN with no port or
 * credentials; otherwise null, so the initials show. The address is a profile field, and an image
 * from any other host would tell that host the admin's IP address whenever the record opens.
 */
export function discordAvatarSrc(url: string | null): string | null {
  if (!url || !URL.canParse(url)) return null
  const { hostname, password, port, protocol, username } = new URL(url)
  const plain = protocol === "https:" && !port && !username && !password
  return plain && DISCORD_AVATAR_HOSTS.has(hostname) ? url : null
}

/** A label from a stored answer key: "old_question" and "oldQuestion" read "Old question". */
export function humanizeKey(key: string) {
  const words = key
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim()
    .toLowerCase()
  return words ? `${words.charAt(0).toUpperCase()}${words.slice(1)}` : key
}
